import { useTranslations } from "next-intl";

import { CodeStyle } from "@/components/doc/right-sidebar/code-style/CodeStyle";
import { ActionsDisclosure } from "@/components/sidebar/ActionsDisclosure";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  isCollapsed?: boolean;
};

export function CodeBlockStyle({ doc, isCollapsed }: Props) {
  const t = useTranslations("sidebar.blocks");

  if (isCollapsed) return <CodeStyle doc={doc} isCollapsed />;

  return (
    <ActionsDisclosure
      data-panel="code_block_style"
      title={t("code.title")}
      disclosureProps={{ defaultOpen: true }}
      disclosurePanelProps={{ className: "-mt-1.25" }}
    >
      <CodeStyle doc={doc} />
    </ActionsDisclosure>
  );
}
